<template>
    <div class="sub-assignment-page">
        <div class="page-container" role="tablist">
            <draggable group="parts"
                       :list="categoriesIn"
                       handl=".single-step-drag-handle"
                       ghost-class="drag-ghost">
                <span v-for="cat in categoriesIn" class="steps-page" :key="cat.name+'-'+cat.id">
                    <design-2021-afaq-category-component
                        @editCategory="editCategory($event)"
                        :category-in="cat"
                        :afaq-tags-in="afaqTagsIn">
                    </design-2021-afaq-category-component>
                </span>
            </draggable>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "design-2021-afaq-category-details-component",
    props: ['categoriesIn', 'afaqTagsIn'],
    components: {
        draggable,
    },
    methods: {
        editCategory(category) {
            this.$emit('editCategory', category);
        },
    }
}
</script>

<style scoped>

</style>
